import styled from 'styled-components';

import { mediaMin, tabletRange } from '@spa/shared/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const CarouselWrapper = styled.div`
  display: flex;
  position: relative;
  gap: ${props => props.theme.gap(4)};
  width: 100%;
  height: 100%;
  overflow-x: hidden;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${props => props.theme.space(4)};

  & > div {
    display: flex;
    gap: ${props => props.theme.space(3)};
  }

  .left,
  .right {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    z-index: 1;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    background-color: ${props => props.theme.simpleCarousel.navigationControls.backgroundColor};
    box-shadow: 0px 3px 10px 0px rgba(34, 66, 81, 0.1);

    svg {
      position: relative;
      width: 8px;
      height: 16px;
    }
  }

  .right {
    cursor: ${props => (props.rightEnabled ? 'pointer' : 'default')};
    pointer-events: ${props => (props.rightEnabled ? 'auto' : 'none')};
    opacity: ${props => (props.rightEnabled ? 1 : 0.5)};

    ${mediaMin.smallBreakpoint`
      display: none;
    `}

    ${tabletRange.ipad()`
      display: none;
    `}

    ${tabletRange.ipad('landscape')`
      display: none;
    `}
  }

  .left {
    cursor: ${props => (props.leftEnabled ? 'pointer' : 'default')};
    pointer-events: ${props => (props.leftEnabled ? 'auto' : 'none')};
    opacity: ${props => (props.leftEnabled ? 1 : 0.5)};

    ${mediaMin.smallBreakpoint`
      display: none;
    `}

    ${tabletRange.ipad()`
      display: none;
    `}

    ${tabletRange.ipad('landscape')`
      display: none;
    `}
  }

  ${mediaMin.largeBreakpoint`
    display: none;
  `}
`;

export const Carousel = styled.div`
  display: flex;
  ${({ theme }) => theme.gap(4)}
  transform: translateX(-${props => props.carouselOffset}px);
  transition: transform 0.5s ease;

  ${mediaMin.mediumBreakpoint`
    width: 100%;
  `}

  ${mediaMin.largeBreakpoint`
    overflow-x: auto;
    max-width: 100%;
    width: 90vw;
  `}
`;
